import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../store/authSlice";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import icons from "../../icons.config";
import { loginApi } from "../../Providers/authProvider";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState(""); // Changed from phone to email
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleLogin = (userData) => {
    if (!userData.token) {
      console.error("Login successful but token is missing!", userData);
      setError("Token is missing from response.");
      return;
    }

    localStorage.setItem("authToken", userData.token);
    dispatch(login({ token: userData.token, user: userData }));
    
    console.log("User logged in, token saved:", localStorage.getItem("authToken")); 
    navigate("/");
  };

  // Validate email format on change
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validate email format before submission
    if (!email) {
      setError("Email is required.");
      return;
    }
    
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const data = await loginApi({ email_id: email, password }); // Use email_id
      console.log("Login successful:", data);
      handleLogin(data);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
        <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
          <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
        </div>
        <div className="hidden lg:block absolute left-8 top-20 z-10">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
        </div>
        <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
          <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">LOGIN</h2>
          {error && <p className="text-red-500 text-center">{error}</p>}

          <form className="space-y-1" onSubmit={handleSubmit}>
            <div className="grid gap-6 md:grid-cols-2">
              <div className="relative">
                <label htmlFor="email" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
                  EMAIL ADDRESS
                </label>
                <input
                  type="email" // Changed type to email
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Enter your email address"
                  className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
                />
              </div>
              <div className="relative">
                <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
                  PASSWORD
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
                />
                <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEye className="text-secondary" /> : <FaEyeSlash className="text-secondary" />}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end text-sm">
              <a href="/forgot-password" className="text-hcolor underline">
                Forgot Password?
              </a>
            </div>

            <div className="lg:px-52">
              <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-sm font-light hover:bg-tertiary hover:border-2 hover:text-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 my-1">
                LOGIN
              </button>
            </div>

            <div className="text-center space-y-6">
              <p className="text-sm text-hcolor">
                Don’t have an account? <a href="/signup" className="text-primary1 underline">Sign Up</a>
              </p>
              <p className="text-sm text-hcolor">
                Having trouble logging in? <a href="/contact" className="text-primary1 underline">Get Help</a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <FooterDoodles />
      <Footer />
    </>
  );
};

export default Login;











// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { login } from "../../store/authSlice";
// import Navbar from "../Navbar/navbar";
// import Footer from "../Footer/footer";
// import FooterDoodles from "../Footer/footerDoodles";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import icons from "../../icons.config";
// import { loginApi } from "../../Providers/authProvider"; // ✅ Import from authProvider
// import { useSelector } from "react-redux";

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [phone, setPhone] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
  
//   const handleLogin = (userData) => {
//     if (!userData.token) {
//       console.error("Login successful but token is missing!", userData);
//       setError("Token is missing from response.");
//       return;
//     }
  
//     localStorage.setItem("authToken", userData.token); // ✅ Store token in localStorage
//     dispatch(login({ token: userData.token, user: userData }));
    
//     console.log("User logged in, token saved:", localStorage.getItem("authToken")); 
//     navigate("/"); // Redirect to home/profile
//   };

//   const handlePhoneChange = (e) => {
//     const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
//     if (value.length <= 10) {
//       setPhone(value); // Allow only up to 10 digits
//     }
//   };
  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
  
//     // Validate phone number before submission
//     if (phone.length !== 10) {
//       setError("Phone number must be exactly 10 digits.");
//       return;
//     }
  
//     try {
//       const data = await loginApi({ mobile_number: phone, password });
//       console.log("Login successful:", data);
//       handleLogin(data);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
    
//         <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
//           <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
//         </div>
//         <div className="hidden lg:block absolute left-8 top-20 z-10">
//           <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
//         </div>
//         <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
//           <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">LOGIN</h2>
//           {error && <p className="text-red-500 text-center">{error}</p>}

//           <form className="space-y-1" onSubmit={handleSubmit}>
//             <div className="grid gap-6 md:grid-cols-2">
//               <div className="relative">
//                 <label htmlFor="phone" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
//                   PHONE NUMBER
//                 </label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={phone}
//                   onChange={handlePhoneChange}
//                   placeholder="Enter your phone number"
//                   className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
//                 />
//               </div>
//               <div className="relative">
//                 <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
//                   PASSWORD
//                 </label>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   id="password"
//                   name="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
//                 />
//                 <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
//                   {showPassword ? <FaEyeSlash className="text-secondary" /> : <FaEye className="text-secondary" />}
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-center justify-end text-sm">
//               <a href="/forgot-password" className="text-hcolor underline">
//                 Forgot Password?
//               </a>
//             </div>

//             <div className="lg:px-52">
//               <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-sm font-light hover:bg-tertiary hover:border-2 hover:text-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 my-1">
//                 LOGIN
//               </button>
//             </div>

//             <div className="text-center space-y-6">
//               <p className="text-sm text-hcolor">
//                 Don’t have an account? <a href="/signup" className="text-primary1 underline">Sign Up</a>
//               </p>
//               <p className="text-sm text-hcolor">
//                 Having trouble logging in? <a href="/help" className="text-primary1 underline">Get Help</a>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//       <FooterDoodles />
//       <Footer />
//     </>
//   );
// };

// export default Login;
